import { Typography, Checkbox } from '@scale/scaleui';
import MultiSelect from 'corp/components/UI/Select';
import useUpdateCourseProgressV2Card from './useUpdateCourseProgressV2Card';
import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import { twMerge } from 'tailwind-merge';
import { compassErrorClassName } from 'react-scale/corp/views/DataCompassCardsV2/utils';

const UpdateCourseProgressV2CardComponent: CompassCardComponent = ({
  index,
}: CompassCardComponentProps) => {
  const {
    selectedCourseProgressV2Column,
    setSelectedCourseProgressV2Column,
    selectedCourseProgressV2StatusColumn,
    setSelectedCourseProgressV2StatusColumn,
    // numCourseProgresses,
    columns,
    shouldTagUsers,
    setShouldTagUsers,
    markAsSkipped,
    setMarkAsSkipped,
    tagIdsColumn,
    setTagIdsColumn,
    hasError,
  } = useUpdateCourseProgressV2Card(index);

  return (
    <div className="flex flex-col gap-4">
      <Typography.Caption>
        Update the status of courseV2 progresses based on the status value from another column. The
        selected status column should contain 'pass' or 'failed' values, which will be used to
        update the corresponding course progress statuses.
      </Typography.Caption>

      <div className="flex gap-4">
        <div className="flex-1 flex flex-col">
          <div className="min-h-[60px]">
            <div className="flex items-start gap-2">
              <Typography.Paragraph2 className="min-w-[180px] shrink-0">
                Course Progress V2 Column
              </Typography.Paragraph2>
              {/* {numCourseProgresses > 0 && (
                <Typography.Caption>
                  {`Selected column has ${numCourseProgresses} ${pluralize(
                    'course progress',
                    numCourseProgresses,
                  )} to be updated.`}
                </Typography.Caption>
              )} */}
            </div>
          </div>
          <MultiSelect
            className={twMerge(
              'rounded-lg',
              hasError && !selectedCourseProgressV2Column && compassErrorClassName,
            )}
            label="Select column"
            multi={false}
            options={columns.map(column => ({
              value: column.id ?? '-',
              label: column.header ?? '-',
            }))}
            disabled={false}
            placeholder={'Select a column with course progress IDs...'}
            isSearchable={true}
            isClearable={true}
            value={selectedCourseProgressV2Column}
            onChange={(e: any) => {
              setSelectedCourseProgressV2Column(e === null ? null : e.value);
            }}
          />
        </div>

        <div className="flex-1 flex flex-col">
          <div className="min-h-[60px]">
            <div className="flex items-start gap-2">
              <Typography.Paragraph2 className="min-w-[180px] shrink-0">
                Status Column
              </Typography.Paragraph2>
              <Typography.Caption>
                Course progress statuses will be updated based on the values in this column.
              </Typography.Caption>
            </div>
          </div>
          <MultiSelect
            className={twMerge(
              'rounded-lg',
              hasError && !selectedCourseProgressV2StatusColumn && compassErrorClassName,
            )}
            label="Select status column"
            multi={false}
            options={columns.map(column => ({
              value: column.id ?? '-',
              label: column.header ?? '-',
            }))}
            placeholder={'Select a boolean column...'}
            isSearchable={true}
            isClearable={true}
            value={selectedCourseProgressV2StatusColumn}
            onChange={(e: any) => {
              setSelectedCourseProgressV2StatusColumn(e === null ? null : e.value);
            }}
          />
        </div>
      </div>

      <Checkbox
        label="Tag Users"
        checked={shouldTagUsers}
        onChange={() => setShouldTagUsers(!shouldTagUsers)}
      />
      <Checkbox
        label="Mark course as skipped"
        checked={markAsSkipped}
        onChange={() => setMarkAsSkipped(!markAsSkipped)}
      />
      {shouldTagUsers && (
        <MultiSelect
          className={twMerge('rounded-lg', hasError && !tagIdsColumn && compassErrorClassName)}
          label="Select column"
          multi={false}
          options={columns.map(column => ({
            value: column.id ?? '-',
            label: column.header ?? '-',
          }))}
          placeholder={'Select a column with tag IDs...'}
          isSearchable={true}
          isClearable={true}
          value={tagIdsColumn}
          onChange={(e: any) => {
            setTagIdsColumn(e === null ? null : e.value);
          }}
        />
      )}
    </div>
  );
};

export default UpdateCourseProgressV2CardComponent;
